module.exports = __webpack_public_path__ + "img/embaixo4.cb59dd41.jpg";